export default __webpack_public_path__ + "static/media/icon-import-api.6ae492e5.svg";